import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { ErrorModal } from '../common'
import { selectAdmin } from './adminSelectors'
import { dismissError } from './adminActions'
import { fetchMonthlyEngineStats } from './adminAPI'
import { MonthlyEngineStatsTable } from './MonthlyEngineStatsTable'
import { MonthRangeForm } from './MonthRangeForm'

export const MonthlyEngineStats = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const from = searchParams.get('from') ?? undefined
  const to = searchParams.get('to') ?? undefined
  const { errors, monthlyEngineStats, lastFetchedRequestId, fetching } = useSelector(selectAdmin)
  // bumped to re-fetch when 表示 is pressed with the range already in the URL
  const [reloadCount, setReloadCount] = useState(0)
  const dispatch = useDispatch<ThunkDispatch<unknown, unknown, UnknownAction>>()
  useEffect(() => {
    const promise = dispatch(fetchMonthlyEngineStats({ from, to }))
    // abort a superseded request so a slow, older response can't overwrite a newer one
    return () => promise.abort()
  }, [dispatch, from, to, reloadCount])

  const handleRangeSubmit = (params: Record<string, string>) => {
    if (new URLSearchParams(params).toString() === searchParams.toString()) {
      setReloadCount((count) => count + 1)
    } else {
      setSearchParams(params)
    }
  }

  return (
    <Container fluid>
      <ErrorModal errors={errors} onClose={(errorKey) => dispatch(dismissError(errorKey))} />
      <Row className='align-items-center'>
        <Col className='fs-3'>月別実行回数（全体）</Col>
      </Row>
      {/* keyed by the last successful request so the inputs re-seed from every response, even an unchanged range */}
      <MonthRangeForm
        key={lastFetchedRequestId ?? 'initial'}
        from={monthlyEngineStats?.from ?? ''}
        to={monthlyEngineStats?.to ?? ''}
        onSubmit={handleRangeSubmit}
      />
      {fetching ? (
        <Spinner animation='border' />
      ) : (
        monthlyEngineStats && <MonthlyEngineStatsTable stats={monthlyEngineStats} />
      )}
    </Container>
  )
}
